import { Dispatch, SetStateAction, useEffect } from 'react';
import styled from 'styled-components';
import { AppTextInput } from './AppTextInput';
import { User } from '../../../authContext/domain/entities/User';
import { isValidEmail } from '../../../configuration/helpers/HelperFunctions';
import { ERROR_PASS_LENGTH } from '../../../configuration/helpers/constants';

interface SignUpFormProps {
  showError?: boolean;
  user: User;
  setUser: Dispatch<SetStateAction<User>>;
  enterFunc: () => void;
}
export const SignUpForm = ({ showError, user, setUser, enterFunc }: SignUpFormProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        enterFunc();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [enterFunc]);
  return (
    <Wrapper>
      <div className="row">
        <AppTextInput
          showError={showError && !isValidEmail(user.email)}
          label="Email*"
          placeholder="email@exemple.com"
          currentVal={user?.email}
          onChange={(newVal: string) => {
            setUser((v) => ({ ...v, email: newVal }));
          }}
        />
        <AppTextInput
          showError={!!(showError && (!user.password || (user.password && user.password?.length < 6)))}
          isPass
          label="Mot de passe*"
          placeholder="Mot de passe"
          errorHint={ERROR_PASS_LENGTH}
          currentVal={user?.password}
          onChange={(newVal: string) => {
            setUser((v) => ({ ...v, password: newVal }));
          }}
        />
        <AppTextInput
          showError={showError && user?.passwordRepeat !== user?.password}
          isPass
          label="Confirmation mot de passe*"
          placeholder="Confirmation mot de passe"
          errorHint="les mots de passe ne correspondent pas"
          currentVal={user?.passwordRepeat}
          onChange={(newVal: string) => {
            setUser((v) => ({ ...v, passwordRepeat: newVal }));
          }}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div``;
